import React from "react";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { SolrAdmin } from "../../components/admin/SolrAdmin";
import styles from "./AdminPage.module.css";
export var SolrAdminPage = function () {
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({ id: "ui-br-agency.pane.title.navigation" }) },
            React.createElement("div", { className: styles.navContainer },
                React.createElement(NavComponent, null))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.title" }) },
            React.createElement(SolrAdmin, null))));
};
